<template>
    <article class="order-widget order-widget--sample mb-2" :class="statusCardClass">
        <div class="order-widget__summary px-3 py-2">
            <div class="d-flex align-items-start justify-content-between gap-2">
                <div class="flex-grow-1 min-w-0">
                    <div class="d-flex flex-wrap align-items-baseline gap-2">
                        <p class="order-widget__product-count fw-bolder text-gray-900 mb-0">{{ order.productCount }}</p>
                        <span v-if="order.id" class="order-widget__reference small text-gray-500">#{{ order.id }}</span>
                    </div>
                </div>
                <span class="order-widget__status flex-shrink-0" :class="statusPillClass">
                    <BootstrapIcon class="me-1 align-middle" :color="statusIconColor" name="circle-fill" :size="10" />
                    <span class="align-middle">{{ order.statusLabel }}</span>
                </span>
            </div>

            <div v-if="badges.length > 0" class="order-widget__meta mt-2">
                <span v-for="badge in badges" :key="badge.key" class="order-widget__meta-item">
                    <BootstrapIcon :name="badge.icon" :size="14" />
                    <span>{{ badge.value }}</span>
                </span>
            </div>
        </div>
    </article>
</template>

<script>
import BootstrapIcon from '@/common/directive/BootstrapIcon.vue'

const STATUS_STYLES = Object.freeze({
    pending: {
        cardClass: 'order-widget--pending',
        pillClass: 'order-widget__status--pending',
        iconColor: 'fill-coral-500 text-coral-500'
    },
    preparing: {
        cardClass: 'order-widget--preparing',
        pillClass: 'order-widget__status--preparing',
        iconColor: 'fill-teal-500 text-teal-500'
    },
    completed: {
        cardClass: 'order-widget--completed',
        pillClass: 'order-widget__status--completed',
        iconColor: 'fill-cyan-500 text-cyan-500'
    }
})

const DEFAULT_STATUS = Object.freeze({
    cardClass: 'order-widget--unknown',
    pillClass: 'order-widget__status--unknown',
    iconColor: 'fill-gray-500 text-gray-500'
})

export default {
    name: 'OrderWidgetSample',
    components: {
        BootstrapIcon
    },
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    computed: {
        statusStyle: function () {
            return STATUS_STYLES[this.order.status] || DEFAULT_STATUS
        },
        statusCardClass: function () {
            return this.statusStyle.cardClass
        },
        statusPillClass: function () {
            return this.statusStyle.pillClass
        },
        statusIconColor: function () {
            return this.statusStyle.iconColor
        },
        badges: function () {
            const badges = []
            if (this.order.customer) badges.push({ key: 'customer', icon: 'person', value: this.order.customer })
            if (this.order.pickup) badges.push({ key: 'pickup', icon: 'box-seam', value: this.order.pickup })
            return badges
        }
    }
}
</script>
